<template>
  <div>
    <v-flex justify="center">
      <RemoveWindow   Type="Case" :removeItem="removeItem" v-model="dialogDelete"   Headline="Ta bort ärende gällande" WarningText="Är du säker på att du vill ta bort detta ärende? Ett ärende som är
              borttaget går inte att återfå."    />
    
      <Detail
        v-model="dialog"
        :Choosen="Choosen"
        :id="id"
        :teachernameandId="teachernameandId"
        :membernameandId="membernameandId"
      />
    </v-flex>

            <v-text-field
          v-model="search"
          label="Sök efter ärende"
          class="mx-4"
        ></v-text-field>
    <v-data-table
      :headers="headers"
      :items="myCases"
      item-key="name"
      :search="search"
      
      :pagination.sync="pagination"
      group-by="currentStep"
      class="elevation-1"
      show-group-by
    >

      <template v-slot:items="props">
        <td class="text-xs-right">{{ props.item.name }}</td>
        <td class="text-xs-right">
            <v-btn   dark v-if="diffrentSteps.findIndex(x=> x.text==  props.item.steps[props.item.steps.length - 1].step)!= -1" :color="diffrentSteps.find(x=> x.text==  props.item.steps[props.item.steps.length - 1].step).color">
             
            {{  props.item.steps[props.item.steps.length - 1].step }}   
             <v-icon class="mx-1 ml-2" dark> {{diffrentSteps.find(x=> x.text== props.item.steps[props.item.steps.length - 1].step).icon}} </v-icon>
          </v-btn>
          <!-- <div v-else>
          {{ props.item.steps[props.item.steps.length - 1].step }}
          </div> -->
        </td>
        <td class="text-xs-right">
          {{
            locfun.getName(
              props.item.steps[0].ownerId,
              teachernameandId,
              membernameandId
            )
          }}
        </td>
        <td class="text-xs-right">
          {{
            locfun.getDate(
              props.item.steps[props.item.steps.length - 1].starttime
            )
          }}
        </td>
        <td class="text-xs-right">
          {{ locfun.getDate(props.item.steps[0].starttime) }}
        </td>
        <td class="text-xs-right">
          {{
            locfun.getName(
              props.item.steps[0].ownerId,
              teachernameandId,
              membernameandId
            )
          }}
        </td>
      <div v-if="typ != 'teacher'">
        <div v-if="props.item.hasOwnProperty('notice')">
          <div v-if="props.item.notice.length == 0">
            <!-- Om Notisens längd är 0 == Bortagen -->
            <td class="text-xs-right" >
              <v-btn
                class="mx-2"
                fab
                dark
                small
                @click="OpenCase(props.item)"
                color="green ligthen-1"
              >
                <v-icon dark> assignment_ind </v-icon>
              </v-btn>
            </td>
          </div>
          <div v-else>
            <v-tooltip left close-delay="2000">
              <template v-slot:activator="{ on, attrs }">
                <td
                  class="text-xs-right"
                  :class="`${
                    props.item.notice.length != 0 ? 'amber darken-3' : ''
                  }`"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-btn
                    class="mx-2"
                    fab
                    dark
                    small
                    @click="OpenCase(props.item)"
                    color="green ligthen-1"
                  >
                    <v-icon dark> assignment_ind </v-icon>
                  </v-btn>
                </td>
              </template>
              <span v-if="props.item.notice.length != 0"
                >{{ FormatText(props.item.notice) }}

                <v-btn
                  class="mx-2"
                  small
                  @click="clearNotice(props.item)"
                  color="yellow ligthen-3"
                >
                  Rensa
                </v-btn>
              </span>
            </v-tooltip>
          </div>
        </div>
        <div v-else>
          <td class="text-xs-right" >
            <v-btn
              class="mx-2"
              fab
              dark
              small
              @click="OpenCase(props.item)"
              color="green ligthen-1"
            >
              <v-icon dark> assignment_ind </v-icon>
            </v-btn>
          </td>
        </div>
        </div>
        <td class="text-xs-right" v-if="role == 'rektor'">
          <v-btn
            class="mx-2"
            fab
            dark
            small
            @click="
              removeItem = props.item;
              dialogDelete = true;
            "
            color="red ligthen-1"
          >
            <v-icon dark> clear </v-icon>
          </v-btn>
        </td>

        <td class="text-xs-right" v-if="typ == 'teacher'">
          <v-hover>
            <v-icon
              slot-scope="{ hover }"
              :color="`${hover ? 'amber darken-3' : 'amber lighten-3'}`"
              :disabled="dis[props.item.name]"
              @click="
                sendNotice([id, props.item]);
                showSuccessSnackbar(
                  'Påminelse angående ' + props.item.name + ' skickad!'
                );
                dis[props.item.name] = true;
              "
            >
              notifications
            </v-icon></v-hover
          >
        </td>
      </template>
            <template v-slot:no-results>
        <v-alert :value="true" color="error" icon="warning">
         Det finns inget resultat för din sökning på "{{ search }}". 
        </v-alert>
      </template>
    </v-data-table>
     <div class="text-xs-center pt-2">
      <v-btn color="light-blue darken-1" dark @click="toggleOrder">Ändra sorteringsordning</v-btn>
      <v-btn color="light-blue darken-1" dark @click="nextSort">Sortera på nästa kolumn</v-btn>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import fun from "../functions";
import Detail from "./Detail";
import RemoveWindow from "../assets/RemoveWindow";
export default {
  name: "DataTable",
  components: {
    Detail,RemoveWindow
  },
  props: {
    myCases: Array,
    id: String,
    schoolId: String,
    typ: String,
    role: String,
  },

  watch: {
    school: function (val) {
      //  (val)
      this.headers.forEach((header) => {
        header.class = val.primary + " lighten-3 white--text";
      });
    },
  },
  created() {
    this.locfun = new fun();
    if (this.typ != "teacher") {
      this.headers.push({
        text: "Ärendesteg",
        value: "Ärendesteg",
        align: "right",
      });
      if (this.role == "rektor") {
        this.headers.push({
          text: "Ta bort",
          value: "Ta bort",
          align: "right",
        });
      }
    } else if (this.typ == "teacher") {
      this.headers.push({ text: "Påminn", value: "Påminn", align: "right" });
    }

    this.myCases.forEach((myCase) => {
      myCase.currentStep = myCase.steps[myCase.steps.length - 1].step;
      this.dis[myCase.name] = false;
    });
  },
  computed: {
    ...mapGetters("schools", ["school"]),
    ...mapGetters("teachers", ["teachernameandId"]),
    ...mapGetters("ehtmembers", ["membernameandId"]),
  },
  methods: {

      toggleOrder () {
        this.pagination.descending = !this.pagination.descending
      },
      nextSort () {
        let index = this.headers.findIndex(h => h.value === this.pagination.sortBy)
        index = (index + 1) % this.headers.length
        index = index === 0 ? index + 1 : index
        this.pagination.sortBy = this.headers[index].value
      },
    

    FormatText(Texts) {
      let outputtext = "";
      Texts.forEach((Text) => {
        outputtext +=
          this.locfun.getName(
            Text.reporter,
            this.teachernameandId,
            this.membernameandId
          ) +
          " har skickat en påminelse den " +
          this.locfun.getDate(Text.time) +
          "| \n";
      });
      return outputtext;
    },

    OpenCase(Case) {
      this.Choosen = Case;
      this.dialog = true;
    },

    ...mapActions("cases", ["removeCase", "sendNotice", "clearNotice"]),
    ...mapActions(["showSuccessSnackbar"]),
  },
  data() {
    return {
      search: '',
      removeItem: { name: "temp", id: "temp" },
      dialogDelete: false,
      dis: {},
      dialog: false,
      Choosen: null,
      pagination: {
          sortBy: 'steps[0].starttime'
        },
      headers: [
        {
          text: "Namn",
          align: "start",
          value: "name",
          // groupable: false,
        },
        { text: "Nuvarande steg", value: "currentStep", align: "right" },
        { text: "Ägare", value: "steps[0].ownerId", align: "right" },
        { text: "Stegets starttid", value: "steps[1].starttime", align: "right" },
        {
          text: "Ärendets starttid",
          value: "steps[0].starttime",
          align: "right",
        },
        { text: "Anmälare", value: "steps[0].ownerId", align: "right" },
      ],
         diffrentSteps: [
        {
          text: "Anmälan",
          color: "pink lighten-2",
          nextStep: [1],
          icon: "email",
        },
        {
          text: "Mottagen",
          color: "blue lighten-2",
          nextStep: [2],
          icon: "check_circle",
        },
        {
          text: "Granskning",
          color: "light-green darken-1",
          nextStep: [3, 6],
          icon: "search",
        },
        {
          text: "Åtgärder beslutas",
          color: "cyan lighten-2",
          nextStep: [4],
          icon: "gavel",
        },
        {
          text: "Åtgärder sätts in",
          color: "red darken-1",
          nextStep: [5, 2],
          icon: "arrow_right",
        },
        {
          text: "Återkoppling ges",
          color: "amber lighten-1",
          nextStep: [6],
          icon: "chat",
        },
        {
          text: "Avslut & Arkivering",
          color: "blue-grey darken-1",
          icon: "archive",
        },
      ],
    };
  },
};
</script>
